var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevataLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 44,
    viewBox: "0 0 64 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7953 17.2873V6.54395L21.2047 28.0306H32L22.524 37.4559H42.7953V28.0306H32L42.7953 17.2873Z",
    fill: "url(#paint0_linear_2335_1335)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2335_1335",
    x1: 32,
    y1: 37.4558,
    x2: 32,
    y2: 6.54395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1898FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699069,
    stopColor: "#784DFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevataLogo);
export default __webpack_public_path__ + "static/media/Levata-Logo.06b9e78b3987e9b540879a0ec58093f7.svg";
export { ForwardRef as ReactComponent };